module.exports = __webpack_public_path__ + "img/team-5.992a4b06.png";